import React from "react";
import { Trash } from "react-feather";

import { TableButton } from "components/TableButton";

export const RemoveButton = ({ removeHandler }) => (
  <TableButton Icon={Trash} onClick={removeHandler} />
);
